"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var UnsubscribedContactModal = function UnsubscribedContactModal(props) {
  return /*#__PURE__*/_react.default.createElement(_ui.ConfirmationModalDialog, (0, _extends2.default)({}, props, {
    type: _ui.ConfirmationDialogTypes.ERROR,
    title: "Sorry, Alyce cannot send this recipient an invitation",
    icon: "eye-slash",
    submitButtonText: "Change recipient"
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, "Sorry, this person has opted-out of Alyce gifts."), /*#__PURE__*/_react.default.createElement(_material.Box, {
    pt: 1,
    pb: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, "How do you wish to continue?")));
};

var _default = UnsubscribedContactModal;
exports.default = _default;